import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'seasonEnable',
    pure: false
})
export class SeasonEnabled implements PipeTransform {
    transform(items: any[], filter: Object): any {

        if (!items) {
            return items;
        }

        return items.filter(item => ((((item.weatherStation || {}).llMarker || {}).options || {}).meta || {}).enable === true);
    }
}


@Pipe({
    name: 'seasonState',
    pure: false
})
export class SeasonStates implements PipeTransform {
    transform(items: any[], filter: any): any {

        if (!items || !filter || filter.geoid === 'US') {
            return items;
        }

        return items.filter(item => ((item.weatherStation || {}).location || {})._id.substr(0, 4) === filter.geoid);
    }
}

@Pipe({
    name: 'seasonStateList',
    pure: false
})
export class SeasonStateList implements PipeTransform {
    transform(items: any[], filter: any): any {

        if (!items || !filter) {
            return items;
        }

        if (filter.geoid === 'US') {
            return items.filter(item => item.geoid !== 'US');
        }

        return items.filter(item => item.geoid === filter.geoid);
    }
}
